<template>
<div>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_header_content">
                <img :src="$props.img_header">
            </div>
            <h2 class="title_header_content">{{ $props.header }}</h2>
        </div>

        <!-- <v-btn class="titlefont_header_content grad-primary-bg d-none d-sm-flex white--text" height="50" width="20%" @click="$router.push('/'+$props.link_back)">
            ย้อนกลับ
        </v-btn>
        <v-btn class="titlefont_header_content grad-primary-bg d-flex d-sm-none white--text" height="50" @click="$router.push('/'+$props.link_back)">
            ย้อนกลับ
        </v-btn> -->
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            image: null
        }
    },
    props: ['header', 'img_header','link_back'],
}
</script>

<style scoped>
    .title_header_content{
        margin-left: 10px;
    }

    .img_title_header_content{
        width: 50px;
    }

    .img_title_header_content > img{
         max-width: 100%;
    }

    .titlefont_header_content{
         font-size: 22px !important;
    }
</style>
